export default __webpack_public_path__ + "static/real-grad-left-87b1f7bce2ece50d6c9724f72cede869.svg";